window.addEventListener('DOMContentLoaded', function() {

  window.okeReviewsWidgetOnInit = function () {
      const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
      if (reviewMain) {
          const observer = new MutationObserver(restrictFormSubmit);
          observer.observe(reviewMain, {childList: true});
          restrictFormSubmit();
      }
  }
  
  window.okeReviewsQandaOnInit = function () {
      const questionMain = document.querySelector('.js-okeReviews-questions-main');
      if (questionMain) {
          const observer = new MutationObserver(restrictFormSubmit);
          observer.observe(questionMain, {childList: true});
          restrictFormSubmit();
      }
  }
  
  function restrictFormSubmit() {
      const reviewsWidgetButtons = document.querySelectorAll(".okeReviews button");
  
      reviewsWidgetButtons.forEach(btn => {
         btn.addEventListener('click', event => {
            event.preventDefault();
         });
      });
  }
  
});